export default "__VITE_ASSET__BGC4FWcY__"